import { render, staticRenderFns } from "./AccidentForm.vue?vue&type=template&id=7d8db92f&scoped=true&"
import script from "./AccidentForm.vue?vue&type=script&lang=js&"
export * from "./AccidentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8db92f",
  null
  
)

export default component.exports